import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'angular-2-local-storage';
import { AngularFirestore } from 'angularfire2/firestore';
import { BehaviorSubject, Observable } from 'rxjs/Rx';
//import { of } from 'rxjs/Observable/of';

const httpOptions = {
  headers: new HttpHeaders()
}

@Injectable()
export class LocationService {
	constructor(private http: HttpClient) {

  }

  getCountries(): Observable<any> {
    return this.http.get("assets/locations/countries.json");
  }

  getStates(): Observable<any> {
    return this.http.get("assets/locations/states.json");
  }

  getCities(): Observable<any> {
    return this.http.get("assets/locations/cities.json");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/locations/location.service.ts